import { gql } from '@apollo/client';

export default gql`
  mutation RollbackVoucherRedemption($voucherCodeLastChars: String!, $bookingReference: String!, $market: String!) {
    rollbackVoucherRedemptionByVoucherCodeLastChars(
      voucherCodeLastChars: $voucherCodeLastChars
      market: $market
      bookingReference: $bookingReference
    ) {
      voucher {
        reference
        alias
        type
        amount
        currency
        validUntil
      }
    }
  }
`;
